<template>
    <div class="container">
        <b-modal
            :model-value="modalEditar"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <!-- <pre> {{ infoEditAct }} </pre> -->
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.tipoActivo }}</label>
                        <div v-for="tipActiv in listaTypeAct" :key="tipActiv.id"> 
                            <p v-if="infoEditAct.tipo_activo == tipActiv.tipo_activo">{{tipActiv.descripcion}}</p> 
                        </div>

                        <div
                            v-for="caracteristica in caractActivo"
                            :key="caracteristica.id"
                            class="mb-3"
                        >
                            <label>{{ caracteristica.descripcion }}</label>

                            <b-form-input
                                v-model="listCaractAct[caracteristica.caracteristica]"
                                class="reset-input"
                            />
                        </div>

                        <label>{{ labels.proveedor }}</label>
                        <b-form-select
                            v-model="form.proveedor"
                            class="reset-input"
                        >
                            <option value=""> {{ labels.select }} </option>
                            <option
                                v-for="tercero in listaTerceros"
                                :key="tercero.id"
                                :value="tercero.identificacion"
                            >
                                {{ tercero.nombre }}
                            </option>
                        </b-form-select>

                        <label>{{ labels.fechaCompra }}</label>
                        <b-form-input
                            v-model="form.fecha_compra"
                            class="reset-input"
                            type="date"
                        />

                        <label>{{ labels.valorCompra }}</label>
                        <b-form-input
                            v-model="form.valor_compra"
                            class="reset-input"
                            type="number"
                        />

                        <label>{{ labels.valorSalvamento }}</label>
                        <b-form-input
                            v-model="form.valor_salvamento"
                            class="reset-input"
                            type="number"
                        />
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="reset-btn-delete me-auto"
                            @click="eliminaRegistro()"
                        >
                            {{ labels.delete }}
                        </b-button>
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="editarActivo()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
                <!-- <pre>{{ infoEditAct[0] }}</pre> -->
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="deleteActivo" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"></InacticaItem>
    </div>
</template>

<script>
import TipoActivo from '../../services/TipoActivo' 
import Tercero from '../../services/Tercero' 
import TipoActivoCaracteristica from '../../services/TipoActivoCaracteristica' 
import ActivoCaracteristica from '../../services/ActivoCaracteristica'; 
import Activos from '../../services/Activos' 
import InacticaItem from '../utils/InacticaItem.vue'; 

export default {
    name : 'Editar',
    props: {
        modalEditar: {
            type: Boolean,
            default: false
        },
        infoEditAct: {
            type: Object,
            default: () => ({})
        }
    },
    components : {InacticaItem},
    data() {
        return {
            form: {
                id: null,
                activo: "",
                tipo_activo: "",
                proveedor: "",
                fecha_compra: "",
                valor_compra: "",
                valor_salvamento: ""
            },
            listaTypeAct: [],
            listaTerceros: [],
            caractActivo: [],
            listCaractAct: {},
            listCrtByAct: [],
            deleteActivo: false,
            idActivo: null
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title: "Editar activo",
                    save : "Guardar",
                    close : "Cerrar",
                    delete : 'Eliminar',
                    select : "Seleccione...", 
                    codigo : 'Código',
                    tipoActivo : 'Tipo activo',
                    proveedor : 'Proveedor',
                    fechaCompra : 'Fecha compra',
                    valorCompra : 'Valor compra',
                    valorSalvamento : 'Valor salvamento',
                    formInfoTitle: "Datos del activo",
                    formInfoSubtitle: "Actualiza la información del activo y guarda los cambios."
                }
            }else{
                return {
                    title: "Edit active",
                    save : "Save",
                    close : "Close",
                    select : "Select...", 
                    delete : 'Delete',
                    codigo : 'Code',
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    fechaCompra : 'Purchase date',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                    formInfoTitle: "Asset details",
                    formInfoSubtitle: "Update the asset information and save the changes."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        editarActivo(){

            const listCaract = this.caractActivo.map(item => ({
                codCaracteristica: item.caracteristica,
                infoCaracterist: item.descripcion,
                caracteristica: this.listCaractAct[item.caracteristica] || ""
            }));

            const existeVacio = listCaract.some(item =>
                !item.caracteristica ||
                item.caracteristica.trim() === ""
            );

            if (existeVacio) {
                this.$toast.error("Característica(s) pendiente(s) por diligenciar");
                return;
            }

            if (
                !this.form.activo ||
                !this.form.tipo_activo ||
                !this.form.proveedor ||
                !this.form.fecha_compra ||
                !this.form.valor_compra ||
                !this.form.valor_salvamento
            ) {
                this.$toast.error('Campo(s) pendiente(s) por diligenciar') 
            }

            const info = {
                id: this.form.id,
                codActivo: this.form.activo,
                tipo_activo: this.form.tipo_activo,
                proveedor: this.form.proveedor,
                fecha_compra: this.form.fecha_compra,
                valor_compra: this.form.valor_compra,
                valor_salvamento: this.form.valor_salvamento,
                idUser: this.$store.state.userId,
                caract_activo: listCaract
            }

            Activos.updateActivoById(info) 
            .then((res) => { 

                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("actualizado");
                    this.cierraModal(); 
                }
            })
            .catch((error) => { console.log(error) })

        },
        cierraModalDelet(){
            this.deleteActivo = false 
        },
        eliminaRegistro(){
            this.idActivo = this.form.id
            this.deleteActivo = true 
        },
        confirmInactivate(){
            // console.log(this.idActivo); 
            Activos.inactivateActivo(this.idActivo) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("eliminado")
                    this.cierraModalDelet()
                    this.cierraModal()                
                }
            })
            .catch((err) => { console.log(err) }) 
        },
        generaCampos(){

            const info = {
                'codActivo' : this.infoEditAct[0].activo, 
                'idUser' : this.$store.state.userId, 
                'lstCrtTpAct' : this.caractActivo 
            }
            // console.log(info); 
            TipoActivoCaracteristica.generaCamposCaract(info) 
            .then((res) => { 
                // console.log(res.data); 
                this.modalEditar = false 
                this.$toast.success(res.data.message) 
            })
            .catch((error) => { 
                if (error.response && error.response.data) { 
                    this.$toast.error(error.response.data.message); 
                }
            })

        }
    },
    mounted(){
        TipoActivo.getAllTipoActivo() 
        .then((res) => { 
            // console.log(res.data.listTipoActivo) 
            this.listaTypeAct = res.data.listTipoActivo 
        })
        .catch((err) => { console.log(err) }) 

        Tercero.getAllTercero() 
        .then((res) => { 
            // console.log(res.data.listTercero); 
            this.listaTerceros = res.data.listTercero 
        })
    },
    watch:{
        infoEditAct: {
            immediate: true,
            handler(value) {

                if (!value?.activo) return;

                Object.assign(this.form, value);

                TipoActivoCaracteristica
                .getTipoActivoCaractByTipAct(this.form.tipo_activo)
                .then((res) => {

                    this.caractActivo = res.data.tipActCar;

                    return ActivoCaracteristica
                    .getActivoCaracteristicaByActivo(this.form.activo);

                })
                .then((res) => {

                    this.listCrtByAct = res.data.listActCrtByAct;

                    this.listCaractAct = {};

                    this.listCrtByAct.forEach(item => {
                        this.listCaractAct[item.caracteristica] = item.valor;
                    });

                })
                .catch(console.error);
            }
        }
    }
}
</script>

<style>
</style>
